module.exports = "https://static.wmbcdn.com/uniweb/images/9f390f2c62b98c2d95043046490c199e.svg";